<template>
  <div id="app">
    <div id="svg-sprite"></div>
    <router-view />
    <el-dialog
      :visible.sync="googleDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="400px"
      class="prompt-dialog-container">
      <div class="prompt-dialog-content">
        <img class="prompt-icon" src="@/assets/img/share-icon/ic-message.svg" alt="" />
        <div class="content-right">
          <p class="title_1">Improve Your Experience</p>
          <p class="title_2">You are using a web browser we currently do not support. Try to use Chrome for a better experience on Trucker Path Command.</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="googleDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getStorage, setStorage} from "@/utils/storage";
import {getUrlParam} from "@/utils/getUrlParam";
import DataServices from "@/data-services";
import { globalImport, sharedServicesMgr} from "@/shared-services";
import {mapGetters} from 'vuex'
import { exportBySearch } from '@/tools/basic-methods'

const preLogin = ({token, userInfo}) => {
  setStorage(token)
  sessionStorage.setItem('updateSubscripte', '')
  localStorage.removeItem("userInfo")
  if(userInfo && userInfo.rememUser){
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  }
  window.stop()
}


export default {
  name: 'App',
  data() {
    return {
      googleDialogVisible: false
    }
  },
  computed:{
    key(){
      return this.$route.fullPath
    },
    ...mapGetters('shareTracking', [
      'shareId'
    ]),
  },
  methods:{
    // 判断浏览器函数
    isMobile(){
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        return true; // 移动端
      }else{
        return false; // PC端
      }
    },
    initUUID() {
      let uuid = sessionStorage.getItem('command_UUID')
      if (!uuid) {
        uuid = new Date().getTime()
        sessionStorage.setItem('command_UUID', uuid)
      }
    },
    storeUrlUtm(){
      const utms = ['utm_source', 'utm_content', 'utm_medium', 'utm_campaign', 'utm_term']
      let marketingUtm = {}
      utms.forEach(i => {
        marketingUtm[i] = getUrlParam(i)
      })
      if(marketingUtm[utms[0]]){
        setStorage(marketingUtm, 'commandRegistMarketingUtm')
      }
      if(getUrlParam('shareId')){
        setStorage({ utm_source : "ShareTrip"}, 'commandRegistMarketingUtm')
      }
    },
    globalMarketingTools(config){
      const defaultConfig = {
        isInit: true,
        isNew: true,
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
        onLoginSuccess: async ({token, userInfo}) => {
          preLogin({token, userInfo})
          let url
          if (config.isUseLocalHref) {
            url = window.location.origin + window.location.pathname + `?shareId=${this.shareId}`
          } else {
            const redirect = this.$route.query.redirect
            url = window.location.origin + (redirect ? redirect : "/map/index")
          }
          window.location.href = url
        },
        onMessage:({type, message}) => {
          this.$message({type, message});
        },
        localStorageUtm: getStorage('commandRegistMarketingUtm') || {},
      }
      globalImport.importNow('MarketingTools').subscribe(() => {
          MarketingTools.openWithConfig({  //eslint-disable-line
            ...defaultConfig, ...config,
          }) //eslint-disable-line
        })
    },

  },
  mounted() {
    this.$root.$on("globalMarketingTools", (config) => {
      this.globalMarketingTools(config)
    })

    sharedServicesMgr.register('CommandLogin', () => {
      return {
        open: ({redirect}) => {
          this.globalMarketingTools({
            isLogin: false,
            onLoginSuccess: async ({token, userInfo}) => {
              preLogin({token, userInfo})
              const redirectTarget = this.$route.query.redirect || redirect
              let url = window.location.origin + (redirectTarget ? redirectTarget : "/map/index")
              window.location.href = url
            },
          });
        },
      }
    })
    
    const params = this.$route.query;
    localStorage.setItem('currentTypeMap', params.currentType || '')
  },
  created() {
    this.initUUID()
    this.storeUrlUtm()
    DataServices.initDataService(this.$root)
    let query = exportBySearch(location.search)
    let token = getUrlParam('trialToken') || query.userToken
    let readOnly = (query.readOnly || '').toString().toLowerCase()
    let pageSource = (query.pageSource || '').toString().toLowerCase()
    if (token) {
      setStorage(token)
      const IMAuth = {
        token: token,
      }
      setStorage(IMAuth, 'IMAuth')
      this.$store.dispatch('im/initIMToken', IMAuth, {root: true})
      if (pageSource === 'superadmin') {
        setStorage('yes', 'x-portal-token')
        setStorage(readOnly, 'x-user-readOnly')
      }
      this.$router.push({ path: '/onboarding' })
    }
    if (this.isMobile() || navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
      this.googleDialogVisible = false
    } else {
      this.googleDialogVisible = true
    }
    // svg-sprite.svg mounted to html
    // axios.get(`${process.env.VUE_APP_CMDSTATICPATH}tp-portal-v2/img/svg-sprite.svg`).then(res => {
    //   document.getElementById('svg-sprite').innerHTML = res.data
    // })
  }
}
</script>

<style lang="scss">
#app {
  // font-family: ;
  // font-family: Avenir,OpenSans, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  height: 100%;
  color: #000;
}
#svg-sprite {
  display: none;
}
body {
  overflow-y:hidden;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
.prompt-dialog-container {
  .el-dialog {
    height: 208px;
    margin-top: calc((100vh - 208px) / 2) !important;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 32px 32px 24px;
      word-break: normal !important;
      .prompt-dialog-content {
        display: flex;
        .prompt-icon {
          flex-shrink: 0;
          margin-right: 12px;
          width: 24px;
          height: 24px;
        }
        .content-right {
          flex: 1;
          .title_1 {
            font-family: HelveticaNeue-Bold, sans-serif;
            font-size: 18px;
            line-height: normal;
            color: #000000;
          }
          .title_2 {
            margin-top: 8px;
            font-family: HelveticaNeue, sans-serif;
            font-size: 14px;
            line-height: 1.29;
            color: #000000;
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0 32px;
      .el-button {
        padding: 10px 24px;
        border-radius: 2px;
        span {
        font-family: HelveticaNeue, sans-serif;
        font-size: 14px;
        line-height: normal;
        color: #ffffff;
        }
      }
    }
  }
}
</style>
